import * as React from 'react';

const authContext = React.createContext();

function useAuth() {
  const [authed, setAuthed] = React.useState(false);
  const [referrer, setReferrer] = React.useState(false);

  React.useEffect(() => {
    if (sessionStorage.getItem('access_token')) {
      setAuthed(sessionStorage.getItem('access_token') ? true : false);
      console.log(authed);
    }

    if (sessionStorage.getItem('access_token_refer')) {
      setReferrer(sessionStorage.getItem('access_token_refer') ? true : false);
      console.log(referrer);
    }
  }, []);

  return {
    authed,
    referrer,
    login() {
      return new Promise((res) => {
        setAuthed(true);
        res();
      });
    },
    logout() {
      return new Promise((res) => {
        setAuthed(false);
        res();
      });
    },
    loginReferrer() {
      return new Promise((res) => {
        setReferrer(true);
        res();
      });
    },
    logoutReferrer() {
      return new Promise((res) => {
        setReferrer(false);
        res();
      });
    },
  };
}
export function AuthProvider({ children }) {
  const auth = useAuth();

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export default function AuthConsumer() {
  return React.useContext(authContext);
}
